import axios from "axios";
const _DOMAIN = "https://app.rhombuss.com";

const _API = `${_DOMAIN}/api/v1.0`;
const _PUB = `${_DOMAIN}/api/public`;


export default {
    _API: _API,
    _PUB: _PUB,
    axios: (token) => {
        return axios.create({
            baseURL: `${_API}`,
            headers: { "Authorization": `${token}` }
        });
    },
}